import { Component, Inject, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../button/button.component';
import { AuthService } from '@core/services/auth.service';
import { TranslationDirective } from '../../translata-modal/translation.directive';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-angebot-abhlenen-dialog-box',
  templateUrl: './angebot-abhlenen-dialog-box.component.html',
  styleUrls: ['./angebot-abhlenen-dialog-box.component.scss'],
  imports: [TranslationDirective, TranslateModule, ButtonComponent],
})
export class AngebotAbhlenenDialogBoxComponent {
  readonly dialogRef = inject(DialogRef);
  imagelang: string;
  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private auth: AuthService
  ) {
    this.imagelang = this.auth.user.lang;
  }
}
